module.exports = __webpack_public_path__ + "img/pro_nine_3.ee0683f9.jpg";